module.exports = __webpack_public_path__ + "static/media/01_details_view.8e596280.png";